import i18n from './i18n';
const useMosaicTranslation = () => ({
  t: (key, options) => i18n.t(key, {
    ns: 'mosaic',
    ...options
  }),
  i18n
});
export default useMosaicTranslation;